'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMemo } from 'react';
import { css } from 'styled-components';
import { toHex } from '../../../../features/helpers/convertToHex';
import { STYLED_RESPONSIVE_BREAKPOINTS, } from '../../../../features/helpers/get-media-query-styling';
import styleToCss, { hasStyleValues, } from '../../../../features/helpers/style-to-css';
const borderSides = {
    all: '1px 1px 1px 1px',
    vertical: '0 1px',
    horizontal: '1px 0',
    left: '0 0 0 1px',
    right: '0 1px 0 0',
    top: '1px 0 0 0',
    bottom: ' 0 0 1px 0',
};
const useDivProps = (props) => {
    return useMemo(() => {
        const currentProps = {};
        const prepareProps = (data, query) => {
            if (data) {
                const { backgroundOpacity, backgroundOpacityHover, borderColor, borderColorHover, hidden, fitContent, fitMaxContent, fitMinContent, fullHeight, bordersSide, flex, style, gap, justify, align, wrap, justifySelf, alignSelf, backgroundColor, borderRadius, overflow, position, } = data;
                if (hidden) {
                    currentProps[query] = css `
            ${currentProps[query]};
            display: none;
          `;
                }
                else {
                    if (flex) {
                        currentProps[query] = css `
              ${currentProps[query]};
              display: flex;
              flex-direction: ${flex};
            `;
                    }
                    if (borderColor) {
                        currentProps[query] = css `
              ${currentProps[query]};
              border-style: solid;
              border-color: ${borderColor};
            `;
                    }
                    if (borderColorHover) {
                        currentProps[query] = css `
              ${currentProps[query]};
              &:hover {
                border-style: solid;
                border-color: ${borderColorHover};
              }
            `;
                    }
                    if (fitContent) {
                        currentProps[query] = css `
              ${currentProps[query]};
              width: fit-content;
              height: fit-content;
              line-height: 1;
            `;
                    }
                    if (fitMaxContent) {
                        currentProps[query] = css `
              ${currentProps[query]};
              width: max-content;
              height: max-content;
              line-height: 1;
            `;
                    }
                    if (fitMinContent) {
                        currentProps[query] = css `
              ${currentProps[query]};
              width: min-content;
              height: min-content;
              line-height: 1;
            `;
                    }
                    if (fullHeight) {
                        currentProps[query] = css `
              ${currentProps[query]};
              height: 100%;
            `;
                    }
                    if (bordersSide) {
                        currentProps[query] = css `
              ${currentProps[query]};
              border-width: ${borderSides[bordersSide]};
            `;
                    }
                    if (backgroundColor) {
                        if (backgroundOpacity) {
                            currentProps[query] = css `
                ${currentProps[query]};
                background-color: ${backgroundColor}${toHex(backgroundOpacity)};
              `;
                        }
                        else {
                            currentProps[query] = css `
                ${currentProps[query]};
                background-color: ${backgroundColor};
              `;
                        }
                        if (backgroundOpacityHover) {
                            currentProps[query] = css `
                ${currentProps[query]};
                &:hover {
                  background-color: ${backgroundColor}${toHex(backgroundOpacityHover)};
                }
              `;
                        }
                    }
                }
                const fullStyle = Object.assign(Object.assign({}, (style !== null && style !== void 0 ? style : {})), { gap: gap !== null && gap !== void 0 ? gap : style === null || style === void 0 ? void 0 : style.gap, justifyContent: justify !== null && justify !== void 0 ? justify : style === null || style === void 0 ? void 0 : style.justifyContent, alignItems: align !== null && align !== void 0 ? align : style === null || style === void 0 ? void 0 : style.alignItems, flexWrap: wrap !== null && wrap !== void 0 ? wrap : style === null || style === void 0 ? void 0 : style.flexWrap, justifySelf: justifySelf !== null && justifySelf !== void 0 ? justifySelf : style === null || style === void 0 ? void 0 : style.justifySelf, alignSelf: alignSelf !== null && alignSelf !== void 0 ? alignSelf : style === null || style === void 0 ? void 0 : style.alignSelf, borderRadius: borderRadius !== null && borderRadius !== void 0 ? borderRadius : style === null || style === void 0 ? void 0 : style.borderRadius, overflow: overflow !== null && overflow !== void 0 ? overflow : style === null || style === void 0 ? void 0 : style.overflow, position: position !== null && position !== void 0 ? position : style === null || style === void 0 ? void 0 : style.position });
                if (hasStyleValues(fullStyle)) {
                    currentProps[query] = css `
            ${currentProps[query]}
            ${styleToCss(fullStyle)}
          `;
                }
            }
        };
        const { xl: _xl, xxl: _xxl, tablet: _tablet, mobile: _mobile, children, onClick, onDoubleClick, onMouseEnter, onMouseLeave, onPointerEnter, onPointerLeave, id, className } = props, defaultViewProps = __rest(props, ["xl", "xxl", "tablet", "mobile", "children", "onClick", "onDoubleClick", "onMouseEnter", "onMouseLeave", "onPointerEnter", "onPointerLeave", "id", "className"]);
        const generalProps = {
            children,
            onClick,
            onDoubleClick,
            onMouseEnter,
            onMouseLeave,
            onPointerEnter,
            onPointerLeave,
            id,
            className,
        };
        prepareProps(defaultViewProps, '$default');
        STYLED_RESPONSIVE_BREAKPOINTS.forEach((breakpoint) => {
            const breakpointProps = props[breakpoint];
            if (breakpointProps) {
                prepareProps(breakpointProps, `$${breakpoint}`);
            }
        });
        return { currentProps, generalProps };
    }, [props]);
};
export default useDivProps;
